// Limpia la sala seleccionada y manda al selector.
// Se usa cuando el backend responde 403: el salaId guardado ya no es válido
// (sala sin permisos o cambiada), así que hay que volver a elegirla.
export const SALA_SELECTOR_PATH = '/selector'

export function clearSalaSession() {
  localStorage.removeItem('salaId')
  localStorage.removeItem('sala')
  localStorage.removeItem('globalConf')
  // Avisa a App/SiteContext para que el tema y el contexto dejen de usar la sala vieja
  window.dispatchEvent(new Event('salaChanged'))
}

export function resetSalaSessionAndRedirect() {
  const alreadyOnSelector = window.location.pathname === SALA_SELECTOR_PATH

  clearSalaSession()

  if (!alreadyOnSelector) {
    window.location.href = SALA_SELECTOR_PATH
  }
}
